export default __webpack_public_path__ + "static/media/Formular-Bold.78326936.ttf";